import {IGroup} from "../../common/group";
import {InitialState, ACTION_TYPES, Actions} from "./types";


const initialState:InitialState = {
    groups: {},
}

const userStore = (state: InitialState = initialState, {type, payload}: Actions) => {
    switch(type) {
        case ACTION_TYPES.FETCH_GROUPS_SUCCESS:
            return {
                ...state,
                groups: payload.reduce((acc: InitialState['groups'], current: IGroup) => {
                    acc[current.id] = current;
                    return acc;
                }, {}),
            }
        case ACTION_TYPES.GET_GROUP_COURSES_SUCCESS:
            return {
                ...state,
                groups: {
                    ...state.groups,
                    [payload.groupId]: {
                        ...state.groups[payload.groupId],
                        courses: payload.courses,
                    }
                },
            }
        default: 
            return state;
    }
}

export default userStore;